/* Standard Algolia setup */
const { algoliasearch, instantsearch } = window;

const searchClient = algoliasearch(
  'TNAQS1IWC9',
  '3aac9610bf3b4c1adf4a4f7337caa7e8'
);

/* --------------------------------------------------------------------------
   SHARED HELPERS
   -------------------------------------------------------------------------- */
const getImpactColor = (impact) => {
  const impactLower = (impact || '').toLowerCase();
  switch (impactLower) {
    case 'critical': return '#ef4444';
    case 'high': return '#f97316';
    case 'medium': return '#eab308';
    default: return '#3b82f6';
  }
};

/* --------------------------------------------------------------------------
   ERROR ANALYSIS TOOL
   -------------------------------------------------------------------------- */
function initErrorAnalysis() {
  const container = document.querySelector('#searchbox');
  if (!container) return;

  let lastPage = 0;
  const search = instantsearch({
    indexName: 'data',
    searchClient,
    future: { preserveSharedStateOnUnmount: true },
    searchFunction(helper) {
      const query = helper.state.query;
      const panel = document.querySelector('#diagnostic-panel');
      const grid = document.querySelector('.app-grid');

      const errorPattern = /(401|403|429|500|504|TypeError|SyntaxError|CORS|Git)/i;
      const isError = errorPattern.test(query);

      if (isError && query.length > 2) {
        helper.setQueryParameter('optionalFilters', ['category:Troubleshooting<score=10>']);
        // Auto-show disabled per request: ensure panel remains hidden
        panel.classList.add('hidden');
        grid.classList.remove('with-sidebar');
        document.querySelector('#diagnostic-content').innerHTML = '';
      } else {
        panel.classList.add('hidden');
        grid.classList.remove('with-sidebar');
        document.querySelector('#diagnostic-content').innerHTML = '';
      }
      helper.search();
    },
  });

  // Global Function for View Fix
  window.displayErrorFix = function (objectID) {
    const hit = window.currentHits.find(h => h.objectID == objectID);
    if (!hit) return;

    const content = document.querySelector('#diagnostic-content');
    content.innerHTML = `
      <div style="background: #f0f9ff; padding: 12px; border-radius: 8px; border-left: 4px solid #0ea5e9; margin-bottom: 15px;">
          <p style="font-size: 0.85rem; font-weight: 600; color: #0369a1; margin-bottom: 4px;">Selected Issue</p>
          <p style="font-size: 1rem; font-weight: 700; color: #0c4a6e; margin: 0;">${hit.title}</p>
      </div>
      <div style="margin-bottom: 10px;">
          <p style="font-size: 0.9rem; font-weight: 600; color: var(--text-main); margin-bottom: 8px;">Recommended Action:</p>
          <p style="font-size: 0.95rem; line-height: 1.5; color: var(--text-muted);">${hit.solution}</p>
      </div>
    `;
    document.querySelector('#diagnostic-panel').classList.remove('hidden');
    document.querySelector('.app-grid').classList.add('with-sidebar');

    if (window.innerWidth < 768) {
      document.querySelector('#diagnostic-panel').scrollIntoView({ behavior: 'smooth' });
    }
  };

  search.addWidgets([
    instantsearch.widgets.configure({
      hitsPerPage: 5,
    }),
    instantsearch.widgets.searchBox({
      container: '#searchbox',
      placeholder: 'Search error codes (e.g. 401, 500) or paste logs...',
      autofocus: true,
    }),
    instantsearch.widgets.hits({
      container: '#hits',
      transformItems(items) {
        if (window.activePackageScan && window.activePackageScan.length > 0) {
          return items.filter(hit => {
            return hit.vulnerabilities && hit.vulnerabilities.some(v =>
              v.package && window.activePackageScan.includes(v.package.name)
            );
          });
        }
        return items;
      },
      templates: {
        item: (hit, { html, components }) => html`
          <article class="hit-card">
            <div class="hit-header">
              <div>
                <span class="hit-category">${hit.category}</span>
                <h3 class="hit-title">${components.Highlight({ hit, attribute: 'title' })}</h3>
              </div>
            </div>
            <div class="hit-content">
              <p>${components.Highlight({ hit, attribute: 'content' })}</p>
            </div>
            <div style="margin-top: 1rem; padding-top: 1rem; border-top: 1px solid var(--border-color); display: flex; justify-content: space-between; align-items: center; font-size: 0.85rem; color: var(--text-muted);">
                <span style="display: flex; align-items: center; gap: 6px;">
                  <i class="fa-solid fa-circle" style="font-size: 8px; color: ${getImpactColor(hit.impact)}"></i> 
                  ${hit.impact} Impact
                </span>
                <button onClick="${(event) => { event.stopPropagation(); window.displayErrorFix(hit.objectID); }}"
                  style="background: none; border: none; padding: 0; cursor: pointer; color: var(--primary); font-weight: 600;">
                  View Fix <i class="fa-solid fa-arrow-right"></i>
                </button>
            </div>
          </article>
        `,
      },
    }),
    instantsearch.widgets.pagination({ container: '#pagination' }),
    {
      render({ results }) {
        if (results.page !== lastPage) {
          lastPage = results.page;
          const section = document.querySelector('.results-section');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (results && results.hits) window.currentHits = results.hits;
        const panel = document.querySelector('#diagnostic-panel');
        const content = document.querySelector('#diagnostic-content');
        // Logic for auto-populating sidebar removed regarding user request to keep hidden by default
      }
    }
  ]);

  search.start();

  // Log Analysis Logic (Inline)
  const processBtn = document.getElementById('process-log');
  if (processBtn) {
    processBtn.onclick = () => {
      const val = document.getElementById('log-input').value;
      const match = val.match(/(401|403|429|500|504|TypeError|SyntaxError|CORS)/i);
      if (match) {
        // We need to set query on the helper
        search.helper.setQuery(match[0]).search();
        // Also update the search box to reflect what we found
        const box = document.querySelector('.ais-SearchBox-input');
        if (box) box.value = match[0];

        // Scroll to results
        document.querySelector('.results-section').scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        alert('Could not find a recognized error code in the log. Please try searching manually.');
      }
    };
  }

  // Copy function
  window.copySolution = function () {
    const text = document.querySelector('#diagnostic-content').innerText;
    navigator.clipboard.writeText(text);
  }
}

/* --------------------------------------------------------------------------
   VULNERABILITY SCANNER TOOL
   -------------------------------------------------------------------------- */
function initVulnerability() {
  const container = document.querySelector('#styles-searchbox');
  if (!container) return;

  let lastPage = 0;
  const search = instantsearch({
    indexName: 'Vulnerabilities',
    searchClient,
    searchFunction(helper) {
      const query = helper.state.query;
      const panel = document.querySelector('#vuln-diagnostic-panel');
      const grid = document.querySelector('.app-grid');
      const content = document.querySelector('#vuln-diagnostic-content');

      panel.classList.add('hidden');
      grid.classList.remove('with-sidebar');
      content.innerHTML = '';

      helper.search();
    }
  });

  // Global Function for View Fix
  window.showVulnFix = function (objectID) {
    const hit = window.currentVulnHits.find(h => h.objectID == objectID);
    if (!hit) return;

    const content = document.querySelector('#vuln-diagnostic-content');
    const fixVersion = hit.vulnerabilities && hit.vulnerabilities[0] ? hit.vulnerabilities[0].first_patched_version : 'Check References';

    content.innerHTML = `
      <div style="background: #fff1f2; padding: 12px; border-radius: 8px; border-left: 4px solid #e11d48; margin-bottom: 15px;">
          <p style="font-size: 0.85rem; font-weight: 600; color: #9f1239; margin-bottom: 4px;">Vulnerability Detected</p>
          <p style="font-size: 1rem; font-weight: 700; color: #881337; margin: 0;">${hit.summary || hit.title}</p>
      </div>
      <div style="margin-bottom: 15px; border-bottom: 1px solid var(--border-color); padding-bottom: 15px;">
          <p style="font-size: 0.9rem; font-weight: 600; color: var(--text-main); margin-bottom: 8px;">Remediation:</p>
          <p style="font-size: 0.95rem; line-height: 1.5; color: var(--text-muted); margin-bottom: 10px;">
            Update <strong>${hit.vulnerabilities && hit.vulnerabilities[0] ? hit.vulnerabilities[0].package.name : 'package'}</strong> to version <code style="background: #f1f5f9; padding: 2px 6px; border-radius: 4px; font-weight: 600;">${fixVersion}</code> or higher.
          </p>
      </div>
      <div style="margin-bottom: 15px;">
          <p style="font-size: 0.9rem; font-weight: 600; color: var(--text-main); margin-bottom: 8px;">Description:</p>
          <div style="font-size: 0.9rem; line-height: 1.6; color: var(--text-muted);" class="markdown-body">
            ${marked.parse(hit.description || '')}
          </div>
      </div>
      <div>
         <p style="font-size: 0.9rem; font-weight: 600; color: var(--text-main); margin-bottom: 5px;">Reference:</p>
         <a href="${hit.url}" target="_blank" style="color: var(--primary); font-size: 0.9rem; text-decoration: underline;">View Advisory <i class="fa-solid fa-external-link-alt" style="font-size: 0.75rem;"></i></a>
      </div>
    `;

    document.querySelector('#vuln-diagnostic-panel').classList.remove('hidden');
    document.querySelector('.app-grid').classList.add('with-sidebar');
    if (window.innerWidth < 768) {
      document.querySelector('#vuln-diagnostic-panel').scrollIntoView({ behavior: 'smooth' });
    }
  };

  window.copyVulnSolution = function () {
    const text = document.querySelector('#vuln-diagnostic-content').innerText;
    navigator.clipboard.writeText(text);
  }

  search.addWidgets([
    instantsearch.widgets.configure({
      hitsPerPage: 5,
    }),
    instantsearch.widgets.searchBox({
      container: '#styles-searchbox',
      placeholder: 'Search CVEs (e.g., CVE-2023-1234)...',
      queryHook(query, search) {
        if (query.length > 0) {
          window.activePackageScan = null;
        }
        search(query);
      },
    }),
    instantsearch.widgets.hits({
      container: '#vuln-hits',
      transformItems(items) {
        if (window.activePackageScan && window.activePackageScan.length > 0) {
          return items.filter(hit => {
            return hit.vulnerabilities && hit.vulnerabilities.some(v =>
              v.package && window.activePackageScan.includes(v.package.name)
            );
          });
        }
        return items;
      },
      templates: {
        item: (hit, { html, components }) => {
          const fixVersion = hit.vulnerabilities && hit.vulnerabilities[0] ? hit.vulnerabilities[0].first_patched_version : 'Latest';
          return html`
          <article class="hit-card" style="border-left: 4px solid ${getImpactColor(hit.severity)};">
            <div class="hit-header">
                <div>
                    <span class="hit-category" style="background: #fee2e2; color: #991b1b;">${hit.cve_id || 'VULNERABILITY'}</span>
                    <h3 class="hit-title">${components.Highlight({ hit, attribute: 'summary' })}</h3>
                </div>
                <span style="background: ${getImpactColor(hit.severity)}; color: white; padding: 4px 12px; border-radius: 99px; font-weight: 700; font-size: 0.8rem; text-transform: uppercase;">
                    ${hit.severity}
                </span>
            </div>
            <div class="hit-content">
               <div style="font-size: 0.9rem; color: var(--text-muted); line-height: 1.5; margin-bottom: 1rem;">
                  ${html`<div dangerouslySetInnerHTML="${{ __html: marked.parse(hit.description || '') }}"></div>`}
               </div>
               <div style="margin-top: 1rem; padding-top: 0.5rem; display: flex; justify-content: space-between; align-items: center;">
                   <div>
                        <strong style="color: var(--text-heading);"><i class="fa-solid fa-wrench"></i> Fix Version:</strong>
                        <code style="background: white; padding: 2px 6px; border-radius: 4px; border: 1px solid #e5e7eb; color: #e11d48; font-weight: 600;">${fixVersion}</code>
                   </div>
                   <button onClick="${(event) => { event.stopPropagation(); window.showVulnFix(hit.objectID); }}"
                      style="background: none; border: none; padding: 0; cursor: pointer; color: var(--primary); font-weight: 600;">
                      View Fix <i class="fa-solid fa-arrow-right"></i>
                   </button>
               </div>
            </div>
          </article>
        `},
      },
    }),
    instantsearch.widgets.pagination({ container: '#pagination' }),
    {
      render({ results }) {
        if (results.page !== lastPage) {
          lastPage = results.page;
          const section = document.querySelector('.results-section');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (results && results.hits && results.hits.length > 0) {
          window.currentVulnHits = results.hits;
        }

        const panel = document.querySelector('#vuln-diagnostic-panel');
        const content = document.querySelector('#vuln-diagnostic-content');

        if (results && results.hits.length > 0 && !panel.classList.contains('hidden') && content.children.length === 0) {
          window.showVulnFix(results.hits[0].objectID);
        }
      }
    }
  ]);

  search.start();

  // Expose search instance for external control (Package Scanner)
  window.vulnSearch = search;
}

function initPackageScanner() {
  const btn = document.getElementById('scan-package-btn');
  const clearBtn = document.getElementById('clear-scan-btn');
  if (!btn) return;

  // Clear Logic
  clearBtn.addEventListener('click', () => {
    document.getElementById('package-input').value = '';
    document.getElementById('scan-status').textContent = '';
    if (window.vulnSearch) {
      window.vulnSearch.helper.setQueryParameter('filters', undefined).search();
    }
  });

  // Scan Logic
  btn.addEventListener('click', () => {
    const input = document.getElementById('package-input').value;
    const status = document.getElementById('scan-status');

    // Reset status
    status.textContent = '';
    status.style.color = 'var(--text-muted)';

    if (!input.trim()) {
      status.textContent = 'Please paste a package.json content first.';
      status.style.color = '#ef4444';
      return;
    }

    try {
      const pkg = JSON.parse(input);
      const deps = { ...(pkg.dependencies || {}), ...(pkg.devDependencies || {}) };
      const packages = Object.keys(deps);

      if (packages.length === 0) {
        status.textContent = 'No dependencies found in parsed JSON.';
        status.style.color = '#f97316';
        return;
      }

      status.textContent = `Scanning ${packages.length} packages found...`;

      // Construct Algolia Filters
      // We use 'vulnerabilities.package.name' assuming the structure supports it.
      // Limiting to top 50 to avoid query length issues if necessary.
      const targetPackages = packages;
      const filterString = targetPackages.map(p => `vulnerabilities.package.name:${p}`).join(' OR ');

      if (window.vulnSearch) {
        // Clean up any widget if it exists (legacy)
        if (window.scanFilterWidget) {
          window.vulnSearch.removeWidgets([window.scanFilterWidget]);
          window.scanFilterWidget = null;
        }

        // Set global client-side filter
        window.activePackageScan = targetPackages;

        // Explicitly hide right panel when starting a new scan
        const panel = document.querySelector('#vuln-diagnostic-panel');
        const grid = document.querySelector('.app-grid');
        if (panel) panel.classList.add('hidden');
        if (grid) grid.classList.remove('with-sidebar');

        const content = document.querySelector('#vuln-diagnostic-content');
        if (content) content.innerHTML = '';


        // Search for everything (empty query) so we can filter client-side
        window.vulnSearch.helper
          .clearRefinements()
          .setPage(0)
          .setQuery('')
          .search();

        status.innerHTML = `<i class="fa-solid fa-check"></i> Scanned ${packages.length} packages. Results filtered below.`;
        status.style.color = '#059669';
      }

    } catch (e) {
      status.textContent = 'Invalid JSON format. Please check your input.';
      status.style.color = '#ef4444';
      console.error(e);
    }
  });
}

/* --------------------------------------------------------------------------
   CLOUD COST ESTIMATOR TOOL
   -------------------------------------------------------------------------- */
function initCloudCost() {
  const container = document.querySelector('#cost-searchbox');
  if (!container) return;

  let lastPage = 0;
  const search = instantsearch({
    indexName: 'cloudcosts',
    searchClient,
    searchFunction(helper) {
      const query = helper.state.query;
      const panel = document.querySelector('#cost-analysis-panel');
      const grid = document.querySelector('.app-grid');
      const content = document.querySelector('#cost-analysis-content');

      if (query && query.length > 0) {
        panel.classList.remove('hidden');
        grid.classList.add('with-sidebar');
        // If searching manually, we might want to clear the "Analysis" content or show something else
        // But for now, we'll let the user see the manual results in hits and analysis in sidebar
      } else if (!panel.dataset.forced) {
        panel.classList.add('hidden');
        grid.classList.remove('with-sidebar');
      }
      helper.search();
    }
  });

  search.addWidgets([
    instantsearch.widgets.configure({
      hitsPerPage: 5,
    }),
    instantsearch.widgets.searchBox({
      container: '#cost-searchbox',
      placeholder: 'Search cloud resources (e.g. SQS, S3)...'
    }),
    instantsearch.widgets.hits({
      container: '#cost-hits',
      templates: {
        item: (hit, { html, components }) => {
          // Fallback logic for cost display
          let displayCost = null;
          let costLabel = '';

          if (hit.monthly_est) {
            displayCost = hit.monthly_est;
            costLabel = 'per month';
          } else if (hit.cost_per_million) {
            displayCost = hit.cost_per_million;
            costLabel = 'per million';
          } else {
            // Find any key with 'cost' in it
            const costKey = Object.keys(hit).find(k => k.toLowerCase().includes('cost'));
            if (costKey) {
              displayCost = hit[costKey];
              costLabel = costKey.replace(/_/g, ' ');
            }
          }

          const hourlyHtml = hit.hourly_cost ? html`<div><strong style="color: var(--text-main);">Hourly:</strong> $${hit.hourly_cost}</div>` : '';

          return html`
          <article class="hit-card" style="border-top: 4px solid ${hit.provider === 'AWS' ? '#ff9900' : hit.provider === 'Azure' ? '#008ad7' : '#4285f4'};">
            <div class="hit-header">
                <div>
                  <span class="hit-category" style="background: #f1f5f9; color: #475569; font-size: 0.7rem;">${hit.category}</span>
                  <h3 class="hit-title" style="margin-top: 4px;">${components.Highlight({ hit, attribute: 'title' })}</h3>
                </div>
                <div style="text-align: right;">
                  ${displayCost ? html`
                    <span style="display: block; font-size: 1.25rem; font-weight: 700; color: #059669;">$${displayCost}</span>
                    <span style="font-size: 0.75rem; color: var(--text-muted);">${costLabel}</span>
                  ` : ''}
                </div>
            </div>
            
            <p style="font-size: 0.9rem; color: var(--text-muted); margin-bottom: 1rem;">
              ${components.Highlight({ hit, attribute: 'description' })}
            </p>

            <div style="display: flex; justify-content: space-between; align-items: center; font-size: 0.85rem; padding-top: 10px; border-top: 1px solid #f1f5f9;">
               <div style="display: flex; gap: 15px;">
                   <span><strong style="color: var(--text-main);">Provider:</strong> ${hit.provider}</span>
                   <span><strong style="color: var(--text-main);">Service:</strong> ${hit.service}</span>
                   <span><strong style="color: var(--text-main);">Region:</strong> ${hit.region}</span>
               </div>
               ${hourlyHtml}
            </div>
          </article>
        `},
      },
    }),
    instantsearch.widgets.pagination({ container: '#pagination' }),
    {
      render({ results }) {
        if (results.page !== lastPage) {
          lastPage = results.page;
          const section = document.querySelector('.results-section');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  ]);

  search.start();

  window.copyCostEstimate = function () {
    const text = document.querySelector('#cost-analysis-content').innerText;
    navigator.clipboard.writeText(text);
  };

  document.getElementById('analyze-iac-btn').onclick = async () => {
    const input = document.getElementById('iac-input').value;
    const panel = document.getElementById('cost-analysis-panel');
    const content = document.getElementById('cost-analysis-content');
    const grid = document.querySelector('.app-grid');

    if (!input.trim()) {
      alert('Please paste a Terraform/HCL snippet.');
      return;
    }

    // Regex parsing
    const instanceTypes = [...input.matchAll(/instance_type\s*=\s*"([^"]*)"/g)].map(m => m[1]);
    const instanceClasses = [...input.matchAll(/instance_class\s*=\s*"([^"]*)"/g)].map(m => m[1]);
    const hasS3 = input.toLowerCase().includes('aws_s3_bucket');

    const searchQueries = [...new Set([...instanceTypes, ...instanceClasses])];

    // UI Feedback
    panel.dataset.forced = 'true';
    panel.classList.remove('hidden');
    grid.classList.add('with-sidebar');
    content.innerHTML = '<div style="padding: 20px; text-align: center;"><i class="fa-solid fa-spinner fa-spin"></i> Analyzing IAAC resources...</div>';

    try {
      const index = searchClient.initIndex('cloudcosts');
      // Search for matches
      const searchPromises = searchQueries.map(q => index.search(q, { hitsPerPage: 1 }));
      if (hasS3) searchPromises.push(index.search('S3 Standard Storage', { hitsPerPage: 1 }));

      const results = await Promise.all(searchPromises);

      let tableRows = '';
      let total = 0;

      results.forEach((res, i) => {
        if (res.hits.length > 0) {
          const hit = res.hits[0];

          // Logic for sidebar calculation
          let cost = 0;
          if (hit.monthly_est) {
            cost = hit.monthly_est;
          } else if (hit.hourly_cost) {
            cost = hit.hourly_cost * 730; // Approx monthly hours
          } else if (hit.cost_per_million) {
            cost = hit.cost_per_million * 10; // Mock volume
          } else {
            // Try fallback
            const costKey = Object.keys(hit).find(k => k.toLowerCase().includes('cost'));
            if (costKey && !isNaN(parseFloat(hit[costKey]))) {
              cost = parseFloat(hit[costKey]);
            } else {
              cost = 15.25; // Default fallback if really nothing found
            }
          }

          const score = i < searchQueries.length ? '100%' : '90%'; // Mock score
          const resourceLabel = i < searchQueries.length ? searchQueries[i] : 'S3 Bucket';

          tableRows += `
            <tr>
              <td style="padding: 10px 5px; border-bottom: 1px solid #f1f5f9; font-weight: 500;">
                <span style="font-size: 0.7rem; color: #64748b; display: block; text-transform: uppercase;">${hit.service}</span>
                ${resourceLabel}
              </td>
              <td style="padding: 10px 5px; border-bottom: 1px solid #f1f5f9; text-align: right; color: #0f172a;">$${cost.toFixed(2)}</td>
              <td style="padding: 10px 5px; border-bottom: 1px solid #f1f5f9; text-align: right; color: #10b981; font-weight: 600;">${score}</td>
            </tr>
          `;
          total += cost;
        }
      });

      if (tableRows === '') {
        content.innerHTML = '<div style="padding: 20px; color: #f97316;">No exact matches found for resources. Showing manual search results instead.</div>';
        search.helper.setQuery(searchQueries.join(' ') || 'AWS Instance').search();
        return;
      }

      content.innerHTML = `
        <div style="background: #f0fdf4; padding: 12px; border-radius: 8px; border-left: 4px solid #10b981; margin-bottom: 15px;">
           <p style="font-size: 0.8rem; font-weight: 700; color: #166534; margin-bottom: 2px;">IAAC ANALYSIS COMPLETE</p>
           <p style="font-size: 0.9rem; color: #15803d; margin: 0;">Found ${results.filter(r => r.hits.length > 0).length} matching resources.</p>
        </div>
        <table style="width: 100%; border-collapse: collapse; font-size: 0.85rem;">
          <thead>
            <tr style="text-align: left; color: #64748b; border-bottom: 2px solid #e2e8f0;">
              <th style="padding: 5px;">Resource</th>
              <th style="padding: 5px; text-align: right;">Unit Cost</th>
              <th style="padding: 5px; text-align: right;">Score</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
        <div style="margin-top: 15px; padding: 12px; background: #f8fafc; border-radius: 8px; display: flex; justify-content: space-between; align-items: center;">
          <span style="font-weight: 700; color: #475569;">TOTAL EST.</span>
          <span style="font-size: 1.1rem; font-weight: 800; color: #059669;">$${total.toFixed(2)} <span style="font-size: 0.7rem;">/mo</span></span>
        </div>
        <p style="font-size: 0.75rem; color: #94a3b8; margin-top: 10px; text-align: center;">* Estimates based on ${hasS3 ? 'standard storage rates and ' : ''}on-demand pricing.</p>
      `;

    } catch (error) {
      console.error(error);
      content.innerHTML = '<div style="padding: 20px; color: #ef4444;">Failed to analyze resources. Please try again.</div>';
    }
  };
}

// Initialize
initErrorAnalysis();
initVulnerability();
initCloudCost();
initPackageScanner();

/* --------------------------------------------------------------------------
   STACK ADVISOR TOOL
   -------------------------------------------------------------------------- */
function initStackAdvisor() {
  const btn = document.getElementById('analyze-stack-btn');
  if (!btn) return;

  btn.addEventListener('click', async () => {
    const framework = document.getElementById('stack-framework').value;
    const infra = document.getElementById('stack-infra').value;
    const dashboard = document.getElementById('stack-dashboard');

    // UI Loading State
    dashboard.classList.remove('hidden');
    document.getElementById('security-score').innerHTML = '<i class="fa-solid fa-circle-notch fa-spin" style="font-size: 1.5rem;"></i>';
    document.getElementById('cost-score').innerHTML = '<i class="fa-solid fa-circle-notch fa-spin" style="font-size: 1.5rem;"></i>';
    document.getElementById('stability-score').innerHTML = '<i class="fa-solid fa-circle-notch fa-spin" style="font-size: 1.5rem;"></i>';

    try {
      // 1. Security Check (Vulnerabilities)
      const vulnIndex = searchClient.initIndex('Vulnerabilities');
      // We search for the framework name in packages
      const vulnResults = await vulnIndex.search(framework, { hitsPerPage: 3 });

      const vulnCount = vulnResults.nbHits;
      const vulnScoreEl = document.getElementById('security-score');
      const vulnDetails = document.getElementById('security-details');

      if (vulnCount === 0) {
        vulnScoreEl.textContent = 'A+';
        vulnScoreEl.className = 'metric-value score-good';
        vulnDetails.innerHTML = 'No direct vulnerabilities found for this framework version.';
      } else {
        vulnScoreEl.textContent = vulnCount > 5 ? 'C' : 'B-';
        vulnScoreEl.className = vulnCount > 5 ? 'metric-value score-bad' : 'metric-value score-warn';
        vulnDetails.innerHTML = `Found <strong>${vulnCount}</strong> potential vulnerabilities. Most recent: <br><span style="color: #ef4444;">${vulnResults.hits[0].cve_id || 'CVE-UNKNOWN'}</span>`;
      }

      // 2. Cost Analysis
      const costIndex = searchClient.initIndex('cloudcosts');
      const costResults = await costIndex.search(infra, { hitsPerPage: 1 });

      const costScoreEl = document.getElementById('cost-score');
      const costDetails = document.getElementById('cost-details');

      if (costResults.hits.length > 0) {
        const hit = costResults.hits[0];
        let cost = 0;
        if (hit.monthly_est) cost = hit.monthly_est;
        else if (hit.hourly_cost) cost = hit.hourly_cost * 730;
        else cost = 29.99; // Fallback

        costScoreEl.textContent = `$${cost.toFixed(0)}`;
        costScoreEl.className = 'metric-value'; // Neutral color
        costDetails.innerHTML = `Based on <strong>${hit.service}</strong> pricing model.<br>Includes est. compile time.`;
      } else {
        costScoreEl.textContent = 'N/A';
        costDetails.innerHTML = 'Pricing data not available for this resource.';
      }

      // 3. Stability (Error Patterns)
      const errorIndex = searchClient.initIndex('data');
      // Search for errors related to the framework
      const errorResults = await errorIndex.search(framework, { hitsPerPage: 1, filters: 'category:Troubleshooting' });

      const stabScoreEl = document.getElementById('stability-score');
      const stabDetails = document.getElementById('stability-details');

      if (errorResults.nbHits > 0) {
        stabScoreEl.textContent = `${Math.max(100 - (errorResults.nbHits * 5), 60)}%`;
        stabScoreEl.className = 'metric-value score-warn';
        stabDetails.innerHTML = `Community has logged <strong>${errorResults.nbHits}</strong> common issues.<br>Top issue: ${errorResults.hits[0].title.substring(0, 30)}...`;
      } else {
        stabScoreEl.textContent = '98%';
        stabScoreEl.className = 'metric-value score-good';
        stabDetails.innerHTML = 'Very stable. Few reported issues in our knowledge base.';
      }

    } catch (e) {
      console.error(e);
      alert('Failed to analyze stack. Please check console.');
    }
  });
}

// Init
initStackAdvisor();